import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-walletcard',
  templateUrl: './walletcard.component.html',
  styleUrls: ['./walletcard.component.css']
})
export class WalletcardComponent implements OnInit {

  @Input('has_card_attached')  has_card_attached = false;
  @Input('card_details') card_details:any;
  @Input('has_account_attached') has_account_attached=false;
  @Output() addCard = new EventEmitter();


  constructor() { }

  ngOnInit() {
  } 

  linkCard() {
    this.addCard.emit();
  }
  removeCard(){
    
  }
}
